import { render } from "./aboutDetailHistory.vue?vue&type=template&id=1b0965aa&scoped=true&ts=true"
import script from "./aboutDetailHistory.vue?vue&type=script&lang=ts"
export * from "./aboutDetailHistory.vue?vue&type=script&lang=ts"

import "./aboutDetailHistory.vue?vue&type=style&index=0&id=1b0965aa&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0965aa"]])

export default __exports__